// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".invite-colleague{max-width:37.5rem}", "",{"version":3,"sources":["webpack://./src/Account/InviteColleague/InviteColleague.scss"],"names":[],"mappings":"AAGE,kBACE,iBAAA","sourcesContent":["@use '@unmind/design-system/dist/sass/functions/px-to-rem' as *;\n\n@layer pages {\n  .invite-colleague {\n    max-width: px-to-rem(600);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
